<template>
  <div class="min-h-screen bg-gray-100 pb-20">
    <div class="max-w-[600px] mx-auto">
      
      <!-- Header -->
      <div class="bg-white sticky top-0 z-10 shadow-sm">
        <div class="flex items-center gap-3 p-4">
          <button @click="$router.back()" class="p-1">
            <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
            </svg>
          </button>
          <h1 class="text-lg font-bold text-gray-800 flex-1">Teklif Ver</h1>
        </div>
      </div>

      <!-- Teklif Edilen İlan -->
      <div class="bg-white p-4 mb-2">
        <p class="text-xs text-gray-500 mb-2">Teklif verdiğin ilan</p>
        <div class="flex gap-3">
          <div class="w-16 h-16 bg-gradient-to-br from-takas-sari/30 to-yellow-400/30 rounded-xl flex items-center justify-center">
            <span class="text-2xl">{{ targetListing.icon || '📦' }}</span>
          </div>
          <div class="flex-1">
            <h3 class="font-semibold text-gray-800">{{ targetListing.title }}</h3>
            <p class="text-xs text-gray-500">{{ targetListing.category }} • {{ targetListing.location }}</p>
            <p class="text-xs text-takas-sari font-medium mt-1">{{ targetListing.price || 'Takaslık' }}</p>
          </div>
        </div>
      </div>

      <!-- Teklif Ettiğin İlan -->
      <div class="bg-white p-4 mb-2">
        <div class="flex justify-between items-center mb-3">
          <p class="text-xs text-gray-500">Teklif ettiğin ilan</p>
          <button @click="showMyListings = true" class="text-xs text-takas-sari font-medium">İlan Seç →</button>
        </div>
        
        <div v-if="selectedMyListing" class="flex gap-3">
          <div class="w-16 h-16 bg-gradient-to-br from-takas-sari/30 to-yellow-400/30 rounded-xl flex items-center justify-center">
            <span class="text-2xl">{{ selectedMyListing.icon || '📦' }}</span>
          </div>
          <div class="flex-1">
            <h3 class="font-semibold text-gray-800">{{ selectedMyListing.title }}</h3>
            <p class="text-xs text-gray-500">{{ selectedMyListing.category }}</p>
            <p class="text-xs text-takas-sari font-medium mt-1">{{ selectedMyListing.price || 'Takaslık' }}</p>
          </div>
          <button @click="selectedMyListing = null" class="text-red-500 text-xs">✕</button>
        </div>
        
        <div v-else class="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center">
          <svg class="w-10 h-10 text-gray-400 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
          </svg>
          <p class="text-sm text-gray-500">Teklif edeceğin ilanı seç</p>
          <button @click="showMyListings = true" class="mt-2 text-takas-sari text-sm font-medium">İlanlarımı Gör</button>
        </div>
      </div>

      <!-- Takas Detayları -->
      <div class="bg-white p-4 mb-2">
        <p class="text-xs text-gray-500 mb-3">Takas Detayları</p>
        
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Eklemek İstediklerin</label>
          <textarea 
            v-model="offerMessage" 
            rows="3" 
            class="w-full p-3 border border-gray-200 rounded-xl focus:outline-none focus:border-takas-sari"
            placeholder="Örn: Kutusu mevcut, hediye kılıf ekleyebilirim..."></textarea>
        </div>
        
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Nakit Fark (Opsiyonel)</label>
          <input 
            v-model="cashDifference" 
            type="number" 
            class="w-full p-3 border border-gray-200 rounded-xl focus:outline-none focus:border-takas-sari"
            placeholder="0.00 TL">
          <p class="text-xs text-gray-400 mt-1">Takas + nakit fark ekleyebilirsiniz</p>
        </div>
        
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Takas Yöntemi</label>
          <div class="flex gap-3">
            <label class="flex items-center gap-2">
              <input type="radio" v-model="tradeMethod" value="eldesten" class="text-takas-sari">
              <span class="text-sm">Elden</span>
            </label>
            <label class="flex items-center gap-2">
              <input type="radio" v-model="tradeMethod" value="kargo" class="text-takas-sari">
              <span class="text-sm">Kargo</span>
            </label>
          </div>
        </div>
      </div>

      <!-- Teklif Özeti -->
      <div class="bg-white p-4 mb-2">
        <p class="text-xs text-gray-500 mb-3">Teklif Özeti</p>
        <div class="space-y-2 text-sm">
          <div class="flex justify-between">
            <span class="text-gray-600">Senin ilanın</span>
            <span class="font-medium">{{ selectedMyListing ? selectedMyListing.title : 'Seçilmedi' }}</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">Alacağın ilan</span>
            <span class="font-medium">{{ targetListing.title }}</span>
          </div>
          <div class="flex justify-between" v-if="cashDifference">
            <span class="text-gray-600">Nakit fark</span>
            <span class="font-medium text-green-600">{{ cashDifference }} TL</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">Takas yöntemi</span>
            <span class="font-medium">{{ tradeMethod === 'eldesten' ? 'Elden takas' : 'Kargo ile takas' }}</span>
          </div>
        </div>
      </div>

      <!-- Gönder Butonu -->
      <div class="p-4">
        <button 
          @click="sendOffer" 
          :disabled="!selectedMyListing"
          :class="[
            'w-full py-3 rounded-xl font-bold transition',
            selectedMyListing 
              ? 'bg-takas-sari text-takas-koyu shadow-lg' 
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          ]"
        >
          Teklifi Gönder
        </button>
      </div>
    </div>

    <!-- İlan Seçme Modalı -->
    <div v-if="showMyListings" class="fixed inset-0 bg-black/60 z-50 flex items-end justify-center">
      <div class="bg-white rounded-t-2xl w-full max-w-[600px] max-h-[80vh] flex flex-col">
        <div class="p-4 border-b border-gray-200 flex justify-between items-center">
          <h3 class="text-lg font-bold">İlanlarım</h3>
          <button @click="showMyListings = false" class="text-gray-400 text-xl">✕</button>
        </div>
        
        <div class="flex-1 overflow-y-auto p-4 space-y-3">
          <div 
            v-for="listing in myListings" 
            :key="listing.id"
            @click="selectMyListing(listing)"
            class="flex gap-3 p-3 bg-gray-50 rounded-xl cursor-pointer hover:bg-gray-100 transition"
          >
            <div class="w-12 h-12 bg-gradient-to-br from-takas-sari/30 to-yellow-400/30 rounded-lg flex items-center justify-center">
              <span class="text-xl">{{ listing.icon || '📦' }}</span>
            </div>
            <div class="flex-1">
              <h4 class="font-medium text-gray-800">{{ listing.title }}</h4>
              <p class="text-xs text-gray-500">{{ listing.category }}</p>
              <p class="text-xs text-takas-sari font-medium">{{ listing.price || 'Takaslık' }}</p>
            </div>
            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </div>
          
          <div v-if="myListings.length === 0" class="text-center py-8">
            <p class="text-gray-500">Hiç ilanın yok</p>
            <router-link to="/ilan-ver" class="text-takas-sari text-sm mt-2 inline-block">İlan Ver</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OfferPage',
  data() {
    return {
      listingId: null,
      targetListing: {},
      selectedMyListing: null,
      offerMessage: '',
      cashDifference: '',
      tradeMethod: 'eldesten',
      showMyListings: false,
      myListings: [
        { id: 1, title: 'MacBook Air M1', category: 'Bilgisayar', price: 'Takaslık', icon: '💻' },
        { id: 2, title: 'PlayStation 4', category: 'Oyun & Konsol', price: 'Takas+500₺', icon: '🎮' },
        { id: 3, title: 'Samsung Tab S7', category: 'Tablet', price: 'Takaslık', icon: '📱' }
      ]
    }
  },
  created() {
    this.listingId = this.$route.params.id
    // API'den ilan detayını çek
    this.targetListing = {
      id: this.listingId,
      title: 'iPhone 14 Pro',
      category: 'Telefon',
      location: 'İstanbul',
      price: 'Takaslık',
      icon: '📱'
    }
  },
  methods: {
    selectMyListing(listing) {
      this.selectedMyListing = listing
      this.showMyListings = false
    },
    sendOffer() {
      if (!this.selectedMyListing) {
        alert('Lütfen teklif edeceğin ilanı seç')
        return
      }
      
      const offerData = {
        targetListing: this.targetListing.id,
        myListing: this.selectedMyListing.id,
        message: this.offerMessage,
        cashDifference: this.cashDifference,
        tradeMethod: this.tradeMethod,
        createdAt: new Date().toISOString()
      }
      
      console.log('Teklif gönderildi:', offerData)
      alert('Teklifiniz başarıyla gönderildi!')
      this.$router.back()
    }
  }
}
</script>